import PlatformFeatureEnum from '@constants/enums/platform/feature';

export function organisationHasFeature(organisationLike, feature) {
    if (!organisationLike) {
        return false;
    }

    if (Array.isArray(organisationLike.features)) {
        return organisationLike.features.includes(feature);
    }

    if (typeof organisationLike.hasFeature === 'function') {
        return organisationLike.hasFeature(feature);
    }

    return false;
}

export function hasAdvancedFeePlans(...organisationSources) {
    return organisationSources.some(source => organisationHasFeature(source, PlatformFeatureEnum.ADVANCED_RATE_PLANS));
}
